 

import Tabs from "../tabs";
import { useSelector } from "react-redux";
import CircularLoader from "../../../../components/loaders/circularLoader";
import { Box, Card, CardContent, Grid, Typography, useMediaQuery, TextField, InputAdornment } from "@mui/material";
import SnackbarMessage from "../../../../components/snackBar/snackBar";
import { useState, useEffect } from "react";
import SearchIcon from '@mui/icons-material/Search';


const slotTimings = [
  {
    id: 1,
    slot_name: "09:00 AM - 10:00 AM",
  },
  {
    id: 2,
    slot_name: "10:00 AM - 11:00 AM",
  },
  {
    id: 3,
    slot_name: "11:00 AM - 12:00 PM",
  },
  {
    id: 4,
    slot_name: "12:00 PM - 01:00 PM",
  },
  {
    id: 5,
    slot_name: "01:00 PM - 02:00 PM",
  },
  {
    id: 6,
    slot_name: "02:00 PM - 03:00 PM",
  },
  {
    id: 7,
    slot_name: "03:00 PM - 04:00 PM",
  },
  {
    id: 8,
    slot_name: "04:00 PM - 05:00 PM",
  },
  {
    id: 9,
    slot_name: "05:00 PM - 06:00 PM",
  },
  {
    id: 10,
    slot_name: "06:00 PM - 07:00 PM",
  },
];


export default function SlotTimingList() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { branches, status, error } = useSelector((state) => state.general);

  const [search, setSearch] = useState("");
  // 🌈 Multiple gradient colors (cycled per card)
  const colors = [
    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", // blue-purple
    "linear-gradient(135deg, #ff758c 0%, #ff7eb3 100%)", // pink-red
    "linear-gradient(135deg, #43cea2 0%, #185a9d 100%)",  // green-teal
    "linear-gradient(135deg, #f7971e 0%, #ffd200 100%)",// orange-yellow
    "linear-gradient(135deg, #15d8e6ff 0%, #5b86e5 100%)", // cyan-blue
    "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",// coral-yellow
    "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)", // purple-red
    "linear-gradient(135deg, #30cfd0 0%, #330867 100%)",// teal-indigo
    "linear-gradient(135deg, #fa383fff 0%, #e712a4ff 100%)",  // soft pink
    "linear-gradient(135deg, #50e3eeff 0%, #2c7be9ff 100%)", // aqua-blue
    "linear-gradient(135deg, #691350ff 0%, #5b8ce0ff 100%)", // pink-lavender
    "linear-gradient(135deg, #5fe26cff 0%, #8de1f8ff 100%)", // mint-blue
    "linear-gradient(135deg, #f15d18ff 0%, #5b91e9ff 100%)", // subtle gray-blue
    "linear-gradient(135deg, #df8e1cff 0%, #491604ff 100%)",// peach-cream
  ];


  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (status === "failed") {
      setSnackbar({
        open: true,
        message: error,
        severity: "error",
      });
    }
  }, [status, error]);

  return (
    <div>
      <Tabs />
      <Box>
        {/* Loader */}
        {status === "loading" && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <CircularLoader color="success" />
          </Box>
        )}

        {/* Success */}
        {status === "succeeded" && (
          <>
            <Grid spacing={1} container mt={2}>
              <Grid item size={{ xs: 12, md: 4 }}>
                <TextField
                  size="small"
                  placeholder="Search Slot Time"
                  fullWidth
                  value={search}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (!value.startsWith(" ")) {
                      setSearch(value)
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "#f5f5f5",
                      "&.Mui-focused": {
                        bgcolor: "#fff",
                        boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                      },
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>


            {slotTimings.filter((item) => item.slot_name.toLowerCase().includes(search.toLowerCase())).length !== 0 ? (
              <Grid container spacing={2} mt={2} justifyContent={isMobile ? "center" : "start"}>
                {slotTimings.filter((item) => item.slot_name.toLowerCase().includes(search.toLowerCase())).map((item, index) => (
                  <Grid item key={index}>
                    <Card
                      sx={{
                        borderRadius: 3,
                        width: 220, // ✅ Equal width
                        height: 80, // ✅ Equal height
                        background: colors[index % colors.length], // 🌈 multi-colored
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          boxShadow: "0 8px 16px rgba(0,0,0,0.25)",
                        },
                      }}
                    >
                      <CardContent
                        sx={{
                          textAlign: "center",
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          p: 2,
                        }}
                      >
                        {/* Index */}
                        <Typography
                          variant="body2"
                          sx={{
                            position: "absolute",
                            top: 10,
                            left: 14,
                            opacity: 0.9,
                            fontWeight: 600,
                            fontSize: "0.75rem",
                            color: "#f0f0f0",
                          }}
                        >
                          #{index + 1}
                        </Typography>

                        {/* Branch Name */}
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 500,
                            fontSize: "0.9rem",
                            color: "#ffffff",
                            wordBreak: "break-word",
                          }}
                        >
                          {item.slot_name}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Box sx={{ textAlign: "center", mt: 3 }}>No Data Found</Box>
            )}
          </>
        )}
      </Box>
      <SnackbarMessage open={snackbar.open} message={snackbar.message} severity={snackbar.severity} onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} />
    </div>
  );
}


